import { ReactNode } from "react";

interface ContentWrapperProps {
  children: ReactNode;
  className?: string;
}

export default function ContentWrapper({
  children,
  className = "",
}: ContentWrapperProps) {
  return (
    <div
      className={`flex flex-col gap-4 p-4 rounded-[24px] border border-[var(--color-black-2)] ${className}`}
    >
      {children}
    </div>
  );
}
